import { Box, Card, CardContent, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"
import DatePickerMonitoring from "components/DatePickers/DatePickerMonitoring/DatePickerMonitoring";
import { AppColors } from "resources/AppColors"
import { dateIsValid } from "utils/HelperFunctions"

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiInputBase-input": {
      padding: 2,
      paddingLeft: 4,
      fontSize: '14px',
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
      fontSize: '14px',
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}))

const ChartCardDateCalendarSelect = ({ children, title, selectedDate, setSelectedDate, minDate, maxDate }) => {
  const classes = useStyles();

  const handleChangeDate = (dateObject) => {
    if (dateIsValid(new Date(dateObject))) {
      setSelectedDate(new Date(dateObject));
    }
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <Box>
          <Typography variant='subtitle' gutterBottom>
            {title}
          </Typography>
          <DatePickerMonitoring
            value={selectedDate}
            setValue={handleChangeDate}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              textField: {
                className: classes.textFieldLabel,
              }
            }}
          />
        </Box>
        {/* // ** The chart needs an exclusive container for responsiveness */}
        <Box sx={{ position: "relative", height: "40vh", width: "80vw" }}>
          {children}
        </Box>
      </CardContent>
    </Card>
  );
}

export default ChartCardDateCalendarSelect